import { ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES } from '../../../actions/actionTypes';

export const ESTAT_INICIAL = null;

const estructura = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA:
            return action.estructura;

        case ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES:
            return action.estructuraIDades.estructura;

        default:
            return state;
    }
};

export default estructura;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/estructura.js